// import logo from "./logo.svg";
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./Home";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Survey from "./Survey";

// App.js

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

function App() {
  const [showSuccess, setshowSuccess] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  useEffect(() => {
    setTimeout(() => {
      setshowSuccess(false);
    }, 1000);
  }, [showSuccess]);
  return (
    // <div className="App">
    //   <button className="redBtn">Report Contamination</button>
    // </div>
    <ThemeProvider theme={theme}>
      <Router>
        {/* <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/form">About</Link>
          </li>
        </ul>
      </nav> */}

        {/* <hr /> */}

        <Routes>
          <Route
            path="/"
            element={
              <Home
                setSelectedUser={setSelectedUser}
                showSuccess={showSuccess}
              />
            }
          />
          <Route
            path="/form"
            element={
              <Survey
                showSuccess={showSuccess}
                setshowSuccess={setshowSuccess}
                selectedUser={selectedUser}
              />
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
